import React, { useContext, useState } from 'react'
import { Card, Button, Form, Row, Col, Container } from 'react-bootstrap'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { AuthContext } from '../../AuthContext'
import Cookies from 'js-cookie'

// 定義選項常數
const SHAPE_OPTIONS = [
  { value: 0, label: '顆粒狀' },
  { value: 1, label: '凹凸腸狀' },
  { value: 2, label: '裂痕腸狀' },
  { value: 3, label: '光滑條狀' },
  { value: 4, label: '柔軟塊狀' },
  { value: 5, label: '糊狀' },
  { value: 6, label: '水狀' },
]

const VOLUME_OPTIONS = [
  { value: 0, label: '少量' },
  { value: 1, label: '正常' },
  { value: 2, label: '多量' },
]

const COLOR_OPTIONS = [
  { value: 0, label: '褐色' },
  { value: 1, label: '黃色' },
  { value: 2, label: '灰色' },
  { value: 3, label: '黑色' },
  { value: 4, label: '紅色' },
  { value: 5, label: '墨綠色' },
]

const AddDefecation = ({ onSuccess, onCancel, date }) => {
  const { patient_id } = useParams()
  const { baseUrl, currentUser, extendCookie, setLoginShow } =
    useContext(AuthContext)
  const sessionFromCookie = Cookies.get('session')
  // 添加保護性程式碼來處理cookie不存在的情況
  const { session = '' } = sessionFromCookie
    ? JSON.parse(sessionFromCookie)
    : {}

  const [records, setRecords] = useState([
    {
      startTime: '',
      endTime: '',
      shape: '',
      volume: '',
      color: '',
      comment: '',
    },
  ])

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState({})

  // 添加新的一筆記錄欄位
  const handleAddNewRow = () => {
    setRecords((prev) => [
      ...prev,
      {
        startTime: '',
        endTime: '',
        shape: '',
        volume: '',
        color: '',
        comment: '',
      },
    ])
  }

  // 處理輸入變更
  const handleInputChange = (index, field, value) => {
    setRecords((prev) =>
      prev.map((record, i) =>
        i === index ? { ...record, [field]: value } : record
      )
    )

    // 清除該欄位的錯誤訊息
    if (errors[`${field}_${index}`]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[`${field}_${index}`]
        return newErrors
      })
    }
  }

  // 驗證表單
  const validateForm = () => {
    const newErrors = {}
    let isValid = true

    records.forEach((record, index) => {
      // 檢查開始時間
      if (!record.startTime) {
        newErrors[`startTime_${index}`] = '請輸入開始時間'
        isValid = false
      }

      // 檢查結束時間
      if (!record.endTime) {
        newErrors[`endTime_${index}`] = '請輸入結束時間'
        isValid = false
      }

      // 檢查時間順序
      if (record.startTime && record.endTime) {
        const start = new Date(`${date} ${record.startTime}`)
        const end = new Date(`${date} ${record.endTime}`)
        if (start >= end) {
          newErrors[`time_${index}`] = '結束時間必須晚於開始時間'
          isValid = false
        }
      }

      // 檢查形狀
      if (record.shape === '') {
        newErrors[`shape_${index}`] = '請選擇形狀'
        isValid = false
      }

      // 檢查量
      if (record.volume === '') {
        newErrors[`volume_${index}`] = '請選擇量'
        isValid = false
      }

      // 檢查顏色
      if (record.color === '') {
        newErrors[`color_${index}`] = '請選擇顏色'
        isValid = false
      }
    })

    setErrors(newErrors)
    return isValid
  }

  // 計算持續時間（分鐘）
  const calculateDuration = (startTime, endTime) => {
    const start = new Date(`${date} ${startTime}`)
    const end = new Date(`${date} ${endTime}`)
    return Math.round((end - start) / (1000 * 60))
  }

  // 提交新記錄
  const handleSubmit = async () => {
    if (!session) {
      setLoginShow(true)
      return
    }

    if (!validateForm()) return

    try {
      setIsSubmitting(true)

      // 格式化數據
      const defecation = records.map((record) => ({
        duration: calculateDuration(record.startTime, record.endTime),
        shape: parseInt(record.shape),
        volume: parseInt(record.volume),
        color: parseInt(record.color),
        start_time: `${date} ${record.startTime}:00`,
        end_time: `${date} ${record.endTime}:00`,
        comment: record.comment || '',
      }))

      const response = await axios.post(
        `${baseUrl}/api/crm/patient/measure/addDefecation`,
        {
          patient_id,
          defecation,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
            session: currentUser?.session || session || '',
          },
        }
      )

      if (response.data.message === '新增成功') {
        onSuccess?.()
      }
    } catch (error) {
      console.error('Error adding defecation records:', error)
      if (error.response?.data?.error?.code === '50004') {
        setLoginShow(true)
      } else {
        setErrors({ submit: '新增記錄失敗，請稍後再試' })
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Container className="py-4">
      <div className="mb-4">
        <Button
          variant="link"
          onClick={onCancel}
          className="text-decoration-none text-secondary"
        >
          <h5>
            <i className="fa-solid fa-arrow-left me-2" />
            返回數據收集紀錄
          </h5>
        </Button>
      </div>

      <Card className="position-relative mb-4 rounded-3 p-4">
        {/* 日期和按鈕區域 */}
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="m-0">{date}</h4>
          <div>
            <Button
              variant="outline-primary"
              className="me-2"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              取消
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? '儲存中...' : '儲存'}
            </Button>
          </div>
        </div>

        {/* 記錄輸入區域 */}
        {records.map((record, index) => (
          <Row
            key={index}
            className="mt-3 g-3 justify-content-center align-items-center"
          >
            <Col md={2}>
              <Form.Group>
                <Form.Control
                  type="time"
                  value={record.startTime}
                  onChange={(e) =>
                    handleInputChange(index, 'startTime', e.target.value)
                  }
                  isInvalid={
                    !!errors[`startTime_${index}`] || !!errors[`time_${index}`]
                  }
                  placeholder="開始時間"
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`startTime_${index}`] || errors[`time_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>{' '}
            ～{' '}
            <Col md={2}>
              <Form.Group>
                <Form.Control
                  type="time"
                  value={record.endTime}
                  onChange={(e) =>
                    handleInputChange(index, 'endTime', e.target.value)
                  }
                  isInvalid={!!errors[`endTime_${index}`]}
                  placeholder="結束時間"
                />
                <Form.Control.Feedback type="invalid">
                  {errors[`endTime_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Select
                  value={record.shape}
                  onChange={(e) =>
                    handleInputChange(index, 'shape', e.target.value)
                  }
                  isInvalid={!!errors[`shape_${index}`]}
                >
                  <option value="">選擇形狀</option>
                  {SHAPE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors[`shape_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Select
                  value={record.volume}
                  onChange={(e) =>
                    handleInputChange(index, 'volume', e.target.value)
                  }
                  isInvalid={!!errors[`volume_${index}`]}
                >
                  <option value="">選擇量</option>
                  {VOLUME_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors[`volume_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Select
                  value={record.color}
                  onChange={(e) =>
                    handleInputChange(index, 'color', e.target.value)
                  }
                  isInvalid={!!errors[`color_${index}`]}
                >
                  <option value="">選擇顏色</option>
                  {COLOR_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors[`color_${index}`]}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Control
                placeholder="備註可留空"
                value={record.comment}
                onChange={(e) =>
                  handleInputChange(index, 'comment', e.target.value)
                }
              />
            </Col>
          </Row>
        ))}

        {/* 新增一筆按鈕 */}
        <div className="d-flex justify-content-center mt-3">
          <Button
            variant="primary"
            className="text-white text-decoration-none"
            onClick={handleAddNewRow}
            disabled={isSubmitting}
          >
            + 新增一筆
          </Button>
        </div>
      </Card>

      {errors.submit && (
        <div className="text-danger text-center mt-2">{errors.submit}</div>
      )}
    </Container>
  )
}

export default AddDefecation
